module.exports = __webpack_public_path__ + "img/screen-img-01.1f8bed43.webp";